import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Momnt-Logo-Grayscale.png'


const _withScopeId = n => (_pushScopeId("data-v-397d4b0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-column main-footer__logo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Powered by"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "32px",
    alt: "Logo Image",
    class: "logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Momnt Technologies, Inc. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All Rights Reserved", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 4 Concourse Parkway "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Suite 150 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Atlanta, GA 30328 ")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Support Hours and Contact Info")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", { class: "nested-ul" }, [
    /*#__PURE__*/_createElementVNode("li", null, " Monday-Friday: 8:00 a.m. EST to 8:00 p.m. EST ")
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "nested-ul" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, " merchants@momnt.com ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, " (855) 943-3485 ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_v_container, { class: "pa-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "main-footer__row" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "main-footer__item main-footer__item--logo" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("span", null, "© " + _toDisplayString(_ctx.currentYear), 1),
                _hoisted_3,
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "main-footer__item main-footer__item--address" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "main-footer__item main-footer__item" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}